import { render, staticRenderFns } from "./ActContaModal.vue?vue&type=template&id=1b196d84&scoped=true&"
import script from "./ActContaModal.vue?vue&type=script&lang=js&"
export * from "./ActContaModal.vue?vue&type=script&lang=js&"
import style0 from "./ActContaModal.vue?vue&type=style&index=0&id=1b196d84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b196d84",
  null
  
)

export default component.exports